import { render, staticRenderFns } from "./BankNameHamamatsuIwata.vue?vue&type=template&id=539b6bda&scoped=true&"
import script from "./BankNameHamamatsuIwata.vue?vue&type=script&lang=ts&"
export * from "./BankNameHamamatsuIwata.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "539b6bda",
  null
  
)

export default component.exports